"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProxyDirection = void 0;
var ProxyDirection;
(function (ProxyDirection) {
    ProxyDirection["PUBLISH"] = "publish";
    ProxyDirection["SUBSCRIBE"] = "subscribe";
})(ProxyDirection = exports.ProxyDirection || (exports.ProxyDirection = {}));
//# sourceMappingURL=types.js.map